import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import API from "../../Services/API";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {GiTwoCoins} from "react-icons/gi";
import {TbArrowBadgeLeft, TbSquareRoundedMinus, TbSquareRoundedPlusFilled} from "react-icons/tb";
import { BiInfoCircle} from "react-icons/bi";

const currencyFormat = Intl.NumberFormat('en-US');

const Product = () => {
    const {id , pid} = useParams();
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [product, setProduct] = React.useState([]);
    const [totalPrice, setTotalPrice] = React.useState(parseInt(window.localStorage.getItem("totalPrice")));
    const [cart, setCart] = React.useState([]);


    React.useEffect(() => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");
        if (vendorID !== id) {
            cartItems = null;
        }
        if (cartItems) {
            setCart(cartItems)
        }
        const params = {
            vendor: id
        }

        API.getProduct(params , pid)
            .then((response) => {
                setProduct(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [id , pid]);

    const onContinueClick = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (token) {
            if (window.localStorage.getItem("needRegistration")) {
                navigate('/register');
                return true;
            }
            navigate('/cart');
            return true;
        }
        navigate('/login')
    }

    const onPlusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);

        if (vendorID !== id) {
            cartItems = null;
            setTotalPrice(price)
            window.localStorage.setItem("totalPrice", price);
        }
        let count = 1;
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                count = find_item.count + 1;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("vendorID", id);


        /*      setProducts(products.map((product) => {
                  if (product.id === productID) {
                      if(product.count > 0) {
                          product.count += 1;
                      }
                      else {
                          product.count = 1;
                      }

                   /!*   this.setState({sum_product_selected: this.state.sum_product_selected + 1 ,sum_price: this.state.sum_price + +product.discounted_price })*!/
                  }
                  return product;
              }));*/

    }

    const onMinusClick = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        setTotalPrice(totalPrice - price)
        window.localStorage.setItem("totalPrice", totalPrice - price);

        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const count = find_item.count;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                if (count > 1) {
                    cartItems[objIndex].count = count - 1;
                } else {
                    cartItems.splice(objIndex, 1)
                }
                setCart(cartItems)
                window.localStorage.setItem("cart", JSON.stringify(cartItems));
            }
        }

    }

    const getItemCartCount = (productID) => {
        const find_item = cart.find(x => x.item === productID);
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }



    const price =  isLoaded ? product.vendor_price.discounted_price : 0;
    let finalPrice = isLoaded ? product.vendor_price.discounted_price : 0;
    if(isLoaded  && product.vendor_price.wholesale_amount > 0 && getItemCartCount(product.id) >= product.vendor_price.wholesale_amount) {
        finalPrice = product.vendor_price.wholesale_discounted_price
    }


    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title= {  window.localStorage.getItem("companyName")} hasBack={true}  />

            {
                isLoaded &&
                <section className="container-fluid  mt-2 py-4 rtl   ">
                    <div className="row pb-5 mb-5">

                        <div className="col-12 px-0 ">
                            <div className="row vendor-product mx-2 pt-2">
                                <div className="col-12 ">
                                    <div className=' badge badge-info badge-pill bg-primary-color text-center text-small-3 float-start'>
                                                 <span className='text-small-2'>
                                        {
                                            product.counting_unit?.title
                                        }
                                    </span>
                                        &nbsp;
                                        {
                                            product.in_box_count
                                        }
                                        &nbsp;
                                        {
                                            product.unit
                                        }
                                    </div>
                                    <img src={product.cover_image} alt={product.name} className='product-img' />
                                </div>

                            </div>
                        </div>
{/*                        <div className="col-12 mt-4 text-center fw-bold text-big-2">
                            {product.name}
                        </div>*/}
                      <div className="col-12 p-0">
                          <div className="row vendor-product mx-2 p-2">

                              <div className="col-12 p-1">
                                  <div className="fw-bold text-center text-big-2 my-3">
                                      {product.name}

                                  </div>

                                  {product.vendor_price.consumer_price ?
                                      <div className="text-small-1 pe-3 mt-3 text-muted">
                                          <GiTwoCoins className='ms-2 '/>
                                          قیمت مصرف کننده:
                                          &nbsp;
                                          &nbsp;
                                          {currencyFormat.format(product.vendor_price.consumer_price)}
                                          <span className='text-small-3'>
                                                    &nbsp;
                                              ریال
                                              &nbsp;
                                                    </span>
                                      </div>
                                      : ''
                                  }


                                  {product.vendor_price.each_price ?
                                      <div className="text-small-1 pe-3 mt-2 text-dark ">
                                          <GiTwoCoins className='ms-2 '/>
                                          قیمت هر عدد:
                                          &nbsp;
                                          &nbsp;

                                          {currencyFormat.format(product.vendor_price?.each_price)}
                                          <span className='text-small-3'>
                                                    &nbsp;
                                              ریال
                                              &nbsp;
                                                    </span>


                                      </div>
                                      : ''
                                  }
                                  {product.vendor_price.price ?
                                      <div className=" pe-3 mt-2 text-muted fw-bold">
                                          <GiTwoCoins className='ms-2 '/>
                                          قیمت پایه:
                                          &nbsp;
                                          &nbsp;
                                          {
                                              product.vendor_price.discount_percent > 0 ?
                                                  <span
                                                      className='text-decoration-line-through fw-normal text-small-3 px-2 '>
                                                       {currencyFormat.format(product.vendor_price.price)}

                                            </span> : ''
                                          }
                                          {currencyFormat.format(price)}
                                          &nbsp;
                                          <span className='text-small-3 text-muted'>ریال</span>
                                          &nbsp;
                                          {product.vendor_price.consumer_price > 1 && product.in_box_count > 0 &&
                                          <span className='badge rounded-pill bg-success-subtle text-dark text-small-1'>
                                            {Math.round(((product.vendor_price.consumer_price - (price / product.in_box_count)) / product.vendor_price.consumer_price) * 100)} %

                                              {" "}
                                              سود
                                        </span>
                                          }
                                      </div>
                                      : ''
                                  }

                                  {product.vendor_price.wholesale_discounted_price ?
                                      <div className="text-small-2 pe-3 mt-2 text-muted">
                                          <GiTwoCoins className='ms-2 '/>
                                          قیمت عمده:
                                          &nbsp;
                                          (
                                          بیشتر از
                                          &nbsp;
                                          {
                                              product.vendor_price.wholesale_amount
                                          }
                                          &nbsp;
                                          {
                                              product.counting_unit?.title
                                          }
                                          )
                                          :
                                          &nbsp;
                                          {currencyFormat.format(product.vendor_price.wholesale_discounted_price)}
                                          <span className='text-small-3'>
                                                    &nbsp;
                                              ریال
                                              &nbsp;
                                                    </span>
                                          {product.vendor_price.consumer_price > 1 && product.in_box_count > 0 &&
                                          <span className='badge rounded-pill bg-success-subtle text-dark text-big-1'>
                                            {Math.round(((product.vendor_price.consumer_price - (product.vendor_price?.wholesale_discounted_price / product.in_box_count)) / product.vendor_price.consumer_price) * 100)} %

                                              {" "}
                                              سود
                                        </span>
                                          }
                                      </div>
                                      : ''
                                  }


                              </div>
                              <div className="col-12 px-2 mx-0 mt-0 ">
                                  {
                                      getItemCartCount(product.id) > 0 ?
                                          <div className='float-end mt-3 text-primary fw-bold me-1 '>
                                              {
                                                  currencyFormat.format(getItemCartCount(product.id)  *  finalPrice )
                                              }
                                              &nbsp;
                                              <span className='text-small-3 text-secondary opacity-50'>ریال</span>
                                          </div> : ''
                                  }
                                  <div className="add-minus-products text-start">

                                      {
                                          getItemCartCount(product.id) > 0 ?
                                              <span className="add-product-icon text-secondary "
                                                    onClick={() => {
                                                        onMinusClick(product.id, price);

                                                    }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                      }

                                      {
                                          getItemCartCount(product.id) > 0 ?
                                              <span className="px-2">
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                      }

                                      <span className="add-product-icon   "
                                            onClick={() => {
                                                onPlusClick(product.id, price);

                                            }}>
                                         <TbSquareRoundedPlusFilled className='text-secondary-color'/>
                                    </span>
                                  </div>
                              </div>

                          </div>
                      </div>
                        <div className="col-12 p-0">
                            <div className="row vendor-product mx-2 p-2  ">
                                <div className="col-12 home-separator-text ">
                                    <BiInfoCircle className='ms-2' />
                                    توضیحات کالا
                                </div>


                                <div className="col-12 text-justify ">
                                    <p  dangerouslySetInnerHTML={{ __html: product.description }}></p>
                                </div>

                            </div>

                        </div>
                    </div>
                    {
                        cart.length > 0 ?
                            <div className="row">
                                <div className="col-12 p-2 fixed-bottom max-w-lg">
                                    <button
                                        className="btn btn-success bg-secondary-color text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                                        onClick={onContinueClick}
                                    >
                                        مشاهده سبد خرید
                                        <span className="badge  p-2 float-start">
                                       {/*    <span className='text-white-50 px-2 text-big-2'>
                                                {currencyFormat.format(totalPrice)}

                                               &nbsp;
                                               ریال
                                           </span>*/}
<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                    </button>
                                </div>
                            </div>
                            : ''
                    }
                </section>
            }
        </React.Fragment>
    );
};

export default Product;